<template>
  <div class="corpo-pagina">

    <div class="row row-text">
      <div class="col s12 d-flex justify-content-between align-items-center">
        <h4>{{ translation('my.balance.title') }}</h4>

      </div>
    </div>

    <div class="row row-text">
      <div class="col s12 m6 l6 xl6">

        <table>
          <thead>
            <tr>
              <td>{{ translation('pagina.bilancio.checkins.rimanenti') }}</td>
              <td>{{ checkrimanenti }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ translation('pagina.bilancio.checkins.usati') }}</td>
              <td>{{ checkusate }}</td>
            </tr>
            <tr>
              <td>{{ translation('pagina.bilancio.checkins.totali') }}</td>
              <td>{{ checktotali }}</td>
            </tr>
          </tbody>
        </table>

      </div>

      <div class="col s12 m6 l6 xl6">

        <table>
          <thead>
            <tr>
              <td>{{ translation('pagina.bilancio.email.rimanenti') }}</td>
              <td>{{ emailrimanenti }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ translation('pagina.bilancio.email.usate') }}</td>
              <td>{{ emailusate }}</td>
            </tr>
            <tr>
              <td>{{ translation('pagina.bilancio.email.totali') }}</td>
              <td>{{ emailtotali }}</td>
            </tr>
          </tbody>
        </table>

      </div>

    </div>
    <div class="divider"></div>

    <div class="row row-text">
      <div class="col s12 d-flex justify-content-between align-items-center">
        <h4>{{ translation('page.billint.list.invoice.title') }}</h4>

        <JsonExcel v-if="allInvoices.length > 0 && !isLoading" class="btn-small red ml-2" :data="allInvoices"
          :fields="jsonFields" :name="nameFile">
          <i class="material-icons">file_download</i>
        </JsonExcel>
      </div>
    </div>
    <div class="divider"></div>

    <div class="row row-text">
      <div v-if="isLoading" class="col s12 center-align">
        <p>{{ translation('loading_data') }}...</p>
      </div>

      <div class="col s12" v-else-if="paginatedInvoices.length">
        <table class="striped responsive-table">
          <thead>
            <tr>
              <td>{{ translation('page.billing.titolo.pacchetto') }}</td>
              <td>{{ translation('page.billing.titolo.data.ora.acquisto') }}</td>
              <td>{{ translation('page.billing.titolo.data.ora.pagamento') }}</td>
              <td>{{ translation('page.billing.titolo.importo.pagato') }}</td>
              <td>{{ translation('page.billing.titolo.importo.pagato.status') }}</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in flattenedInvoices" :key="row.key"
              :class="{ 'invoice-detail-row': row.type === 'details' }">
              <!-- Riga principale -->
              <template v-if="row.type === 'main'">
                <td>{{ row.invoice.name }}</td>
                <td>{{ formatDate(row.invoice.invoiceDate) }}</td>
                <td>{{ formatDate(row.invoice.paymentDate) }}</td>
                <td>{{ formatCurrency(row.invoice.price) }}</td>
                <td>{{ translateInvoiceStatus(row.invoice.progress_invoice_name) }}</td>
                <td>
                  <a href="#!" class="btn-flat btn-small" @click.prevent="toggleDetails(row.index)">
                    <i class="material-icons">
                      {{ expandedRows.includes(row.index) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                    </i>
                  </a>
                </td>
              </template>

              <!-- Riga dettaglio -->
              <template v-else>
                <td colspan="6">
                  <div class="detail-container">
                    <h6>{{ translation('page.billing.products.title') || 'Dettaglio Prodotti Acquistati' }}</h6>

                    <table class="detail-table">
                      <thead>
                        <tr>
                          <th>{{ translation('page.billing.products.name') || 'Prodotto' }}</th>
                          <th>{{ translation('page.billing.products.quantity') || 'Quantità' }}</th>
                          <th>{{ translation('page.billing.products.price') || 'Prezzo Unitario' }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, pIndex) in row.invoice.products" :key="pIndex">
                          <td>{{ translation(product.name) || product.name }}</td>
                          <td>{{ product.quantity }}</td>
                          <td>{{ formatCurrency(product.siglePrice) }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <p v-if="!row.invoice.products || row.invoice.products.length === 0">
                      {{ translation('page.billing.products.no_items') || 'Nessun dettaglio prodotto disponibile.' }}
                    </p>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>

        </table>

        <PaginationControls v-if="totalPages > 1" :current-page="currentPage" :total-pages="totalPages"
          :items-per-page="itemsPerPage" :str-per-pag="translation('pagination.itemsPerPage')"
          :str-pag="translation('pagination.page')" @page-changed="handlePageChange"
          @items-per-page-changed="handleItemsPerPageChange" />
      </div>

      <div v-else class="col s12 center-align">
        <p>{{ translation('page.billing.titolo.non.trovato') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'
import PaginationControls from '@/components/PaginationControls.vue'
import apiService from '@/services/apiService.js'
import useAuthStore from '@/store/authStore.js'
import JsonExcel from 'vue-json-excel'
import eventSetting from '@/store/eventSettings.js'

export default {
  components: {
    PaginationControls,
    JsonExcel
  },

  data () {
    return {
      // Bilancio email
      emailtotali: 0,
      emailusate: 0,
      emailrimanenti: 0,

      // Bilancio check-in
      checktotali: 0,
      checkusate: 0,
      checkrimanenti: 0,

      // Store
      translationStore,
      authStore: useAuthStore,
      loadingStore,

      // Tabella fatture
      expandedRows: [],
      allInvoices: [],
      currentPage: 0,
      itemsPerPage: 10,
      sortBy: 'id',
      direction: 'DESC',

      // Export XLS
      nameFile: `purchases_${dayjs().format('YYYYMMDD')}.xls`,
      jsonFields: {
        'Nome Pacchetto': 'name',
        'Data Acquisto': {
          field: 'invoiceDate',
          callback: (value) => this.formatDate(value)
        },
        'Data Pagamento': {
          field: 'paymentDate',
          callback: (value) => this.formatDate(value)
        },
        'Importo Pagato (EUR)': {
          field: 'price',
          callback: (value) => this.formatCurrency(value)
        },
        'Stato Pagamento Tradotto': {
          field: 'progress_invoice_name',
          callback: (value) => this.translateInvoiceStatus(value)
        }
      }
    }
  },

  computed: {
    translation () {
      return this.translationStore.getters.traduzione
    },

    fullEventData () {
      if (eventSetting && eventSetting.getters) {
        return eventSetting.getters.eventModel || {}
      }
      return {}
    },

    isLoading () {
      return this.loadingStore.getters.isLoading
    },

    userId () {
      return this.authStore.getters.uid || null
    },

    currentLocaleCode () {
      const rawLocale = this.translationStore.getters.linguaCorrente
      return rawLocale ? rawLocale.replace('_', '-') : 'it-IT'
    },

    userTimeFormat () {
      if (this.authStore && this.authStore.getters && this.authStore.getters.userInfo) {
        const userData = this.authStore.getters.userInfo

        if (
          userData.company_id &&
          userData.company_id.country &&
          userData.company_id.country.timezone &&
          userData.company_id.country.timezone.time_format
        ) {
          return userData.company_id.country.timezone.time_format
        }
      }
      return 'YYYY-MM-DD HH:mm:ss'
    },

    userCurrencyCode () {
      return 'EUR'
    },

    totalPages () {
      if (!this.allInvoices.length) return 0
      return Math.ceil(this.allInvoices.length / this.itemsPerPage)
    },

    paginatedInvoices () {
      const start = this.currentPage * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.allInvoices.slice(start, end)
    },

    storeBalance () {
      const balanceGetter = (this.authStore && this.authStore.getters && this.authStore.getters.balance)
      return balanceGetter || null
    },

    // Riga principale + riga dettaglio "espansa"
    flattenedInvoices () {
      const rows = []

      this.paginatedInvoices.forEach((invoice, index) => {
        const baseKey = invoice.id || index

        // Riga principale
        rows.push({
          type: 'main',
          key: 'row-' + baseKey,
          invoice,
          index
        })

        // Riga dettaglio (solo se espansa)
        if (this.expandedRows.includes(index)) {
          rows.push({
            type: 'details',
            key: 'details-' + baseKey,
            invoice,
            index
          })
        }
      })

      return rows
    }
  },

  methods: {
    /**
     * Inizializza/rinfresca pagina:
     * - reset paginazione
     * - svuota righe espanse
     * - ricarica bilancio + fatture
     */
    initPage () {
      this.currentPage = 0
      this.expandedRows = []
      this.loadInvoices()
    },

    toggleDetails (index) {
      const i = this.expandedRows.indexOf(index)
      if (i > -1) {
        this.expandedRows.splice(i, 1)
      } else {
        this.expandedRows.push(index)
      }
    },

    async loadInvoices () {
      this.loadingStore.commit('setLoading', true)
      this.allInvoices = []
      this.expandedRows = []

      try {
        const token = await apiService.getClientCredentialsToken()
        if (!token) {
          this.$router.push('/error')
          return
        }

        const uid = this.userId
        if (!uid) {
          this.$router.push('/login')
          return
        }

        // 1. Caricamento bilancio
        const urlBalance = `${process.env.VUE_APP_URL_EVENTS}/checkins/get-balance/${uid}`
        const jsonBalance = await apiService.sendRequestWithBearer('GET', urlBalance, token, null, null)

        let balance = jsonBalance
        if (typeof jsonBalance === 'string') {
          try {
            balance = JSON.parse(jsonBalance)
          } catch (e) {
            console.error('Errore nel parse del bilancio:', e)
            balance = null
          }
        }

        if (balance) {
          // aggiorna store
          await this.authStore.dispatch('newBalance', balance)
          // aggiorna campi locali
          this.updateLocalBalance(balance)
        }

        // 2. Caricamento Fatture
        const url = `${process.env.VUE_APP_URL_USER}/billing/list`

        const payload = {
          user_id: uid,
          page: 0, // lato client gestisci tu la paginazione
          size: 9999,
          sortBy: this.sortBy,
          direction: this.direction
        }

        const jsonInvoices = await apiService.sendRequestWithBearer('POST', url, token, payload)

        let rawInvoices = []
        if (Array.isArray(jsonInvoices)) {
          rawInvoices = jsonInvoices
        } else if (jsonInvoices && jsonInvoices.content && Array.isArray(jsonInvoices.content)) {
          rawInvoices = jsonInvoices.content
        }

        this.allInvoices = rawInvoices.map(invoice => ({
          ...invoice,
          products: invoice.products || []
        }))

        // Sicurezza: se la pagina corrente è oltre il totale, riporta all'ultima
        if (this.currentPage >= this.totalPages && this.totalPages > 0) {
          this.currentPage = this.totalPages - 1
        }
      } catch (error) {
        console.error('Errore nel caricamento delle fatture/bilancio:', error)
        this.allInvoices = []
      } finally {
        this.loadingStore.commit('setLoading', false)
      }
    },

    handlePageChange (newPage) {
      if (newPage >= 0 && newPage < this.totalPages) {
        this.currentPage = newPage
        this.expandedRows = []
      }
    },

    handleItemsPerPageChange (newSize) {
      this.itemsPerPage = newSize
      this.currentPage = 0
      this.expandedRows = []
    },

    formatDate (dateString) {
      const format = this.fullEventData?.timezone?.time_format || 'YYYY-MM-DD'
      const tz = this.fullEventData?.timezone?.timezone_name || 'UTC'

      return this.$formatEventDate(dateString, format, tz)
    },

    formatCurrency (amount) {
      return new Intl.NumberFormat(this.currentLocaleCode, {
        style: 'currency',
        currency: this.userCurrencyCode
      }).format(amount)
    },

    translateInvoiceStatus (statusName) {
      const translations = {
        CREATA: this.translation('status.invoice.creata'),
        ATTESA: this.translation('status.invoice.attesa'),
        FALLITO: this.translation('status.invoice.fallito'),
        'PAGATA ATTESA FATTURA': this.translation('status.invoice.pagata.attesa'),
        'FATTURATA ATTESA PAGAMENTO': this.translation('status.invoice.fatturata.attesa'),
        CHIUSA: this.translation('status.invoice.closed')
      }

      const translatedText = translations[statusName] || statusName
      return String(translatedText).toUpperCase()
    },

    updateLocalBalance (bala) {
      if (!bala) return

      const r = bala.remaining || {}
      const t = bala.total || {}
      const u = bala.used || {}

      this.emailrimanenti = r.emails || 0
      this.checkrimanenti = r.checkins || 0

      this.emailtotali = t.emails || 0
      this.checktotali = t.checkins || 0

      this.emailusate = u.emails || 0
      this.checkusate = u.checkins || 0
    }
  },

  // ✅ Quando entri nella pagina (prima montaggio / navigazione router)
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.initPage()
    })
  },

  // ✅ Quando resti sullo stesso componente ma cambia la route (es. rientri da un'altra pagina)
  beforeRouteUpdate (to, from, next) {
    this.initPage()
    next()
  },

  // ✅ Fallback: se il componente è montato fuori dal router o senza beforeRouteEnter
  async mounted () {
    if (!this.allInvoices.length) {
      await this.loadInvoices()
    }
  },

  watch: {
    // Se cambia il bilancio nello store da qualche altra parte (es. dopo un acquisto),
    // sincronizza subito i numeri mostrati a video
    storeBalance: {
      deep: true,
      immediate: true,
      handler (bala) {
        this.updateLocalBalance(bala)
      }
    },

    // Se cambia l'utente loggato, reset pagina e ricarica
    userId () {
      this.initPage()
    }
  }
}
</script>

<style scoped>
/* Stili specifici del componente */
table {
  width: 100%;
  margin-top: 20px;
}

.divider {
  margin: 20px 0;
}

.d-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ml-2 {
  margin-left: 1rem;
}

/* STILI PER IL DETTAGLIO ESPANSO */
.invoice-detail-row {
  background-color: #f7f7f7 !important;
}

.detail-container {
  padding: 15px;
}

.detail-container h6 {
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 500;
  color: #555;
}

.detail-table {
  width: 100%;
  margin-bottom: 0;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.detail-table th,
.detail-table td {
  padding: 8px 15px;
  text-align: left;
}

/* Rotazione dell'icona del bottone */
.material-icons {
  transition: transform 0.3s ease;
  vertical-align: middle;
}

.material-icons.rotated {
  transform: rotate(45deg);
}
</style>
